import React from "react";
import { getUIColorPalette } from "../../../theme/ColorPalette";
import ItineraryTransportIcon from "../shared/ItineraryTransportIcon";
import { formatTransferDuration } from "./itineraryDetails.tools";

interface ItineraryDetailsTransferRowProps {
    "fromMs":   number;
    "legId":    string;
    "toMs":     number;
    "isDarkUi": boolean;
}

const TRANSFER_ICON_MODE = "corres";
const TRANSFER_LABEL_PREFIX = "Correspondance de";

const ItineraryDetailsTransferRow: React.FC<ItineraryDetailsTransferRowProps> = ( { fromMs, legId, toMs, isDarkUi } ) => {
    const palette = getUIColorPalette( isDarkUi );

    return (
        <div
            className="flex items-center"
            id={`itinerary-details-leg-${ legId }-transfer`}
        >
            <div className="flex w-1/12 items-center justify-center">
                {ItineraryTransportIcon( TRANSFER_ICON_MODE )}
            </div>
            <div className="flex w-11/12">
                <span
                    className="max-w-[95%] text-xs font-semibold"
                    style={{ "color": palette.overlayTextSecondary }}
                >
                    {TRANSFER_LABEL_PREFIX}
                    {" "}
                    {formatTransferDuration( fromMs, toMs )}
                </span>
            </div>
        </div>
    );
};

export default ItineraryDetailsTransferRow;
